import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import type { Contacts } from '@albacross/types'

import { get } from 'utils/http'

export const useCustomerContactsPhoneQuota = (specificCustomerId?: any) => {
  const urlParamsCustomerId = useCustomerId()
  const customerId = specificCustomerId || urlParamsCustomerId

  return useQuery<Contacts.UsageAnswer>({
    queryKey: ['customer', customerId, 'contacts_phone_quota'],
    queryFn: () => get(`/management/customers/${customerId}/contacts/phone_usage?`),
  })
}
